import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CustomUpdatePasswordComponentService } from '@my-account/feature';
import { FormFieldNewComponent } from '@sdvor/shared/ui';
import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { ButtonSizes, ButtonThemes } from '@shared/v2';
import { SpinnerComponent } from '@spartacus/storefront';

@Component({
  selector: 'sd-custom-update-password',
  templateUrl: './custom-update-password.component.html',
  styleUrls: ['./custom-update-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CustomUpdatePasswordComponentService],
  imports: [SpinnerComponent, ReactiveFormsModule, FormFieldNewComponent, SdvorButtonComponent, AsyncPipe],
})
export class CustomUpdatePasswordComponent {
  form: FormGroup = this.customUpdatePasswordComponentService.form;
  isUpdating$ = this.customUpdatePasswordComponentService.isUpdating$;
  buttonThemes = ButtonThemes;
  buttonSizes = ButtonSizes;

  isTablet$ = this.deviceService.isTabletMdDown$;

  constructor(
    private deviceService: DeviceService,
    private customUpdatePasswordComponentService: CustomUpdatePasswordComponentService,
  ) {}

  onSubmit(): void {
    this.customUpdatePasswordComponentService.updatePassword();
  }
}
